import React, { ChangeEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RootState, useAppDispatch } from '../../../../redux/store/store'
import { useSelector } from 'react-redux'
import { GetTrackingLinksInfluencersThunk, InfluencerDataCount, setAddTrackLinkState, setDeleteTrackLinkState, setEditTrackLinkState } from '../../../../redux/slices/components/TrackingLinksInfluencers/TrackingLinksInfluencersSlice'
import * as XLSX from 'xlsx-js-style';
import "./TrackingLinksInfluencersScreen.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FaCircle } from 'react-icons/fa'
import { checkErrors, checkErrorsWhenSubmit, ValuesForm } from '../../../../utils/verifications/Forms'
import { MyYup } from '../../../../utils/verifications/myYup'
import GeneralInputTitle from '../../../../components/UIcomponents/GeneralInputTitle/GeneralInputTitle'
import ConfirmButton from '../../../../components/UIcomponents/Modals/ConfirmButton/ConfirmButton'
import { CreateTrackingLinkBody, createTrackingLinksData, deleteTrackingLinksData, updateTrackingLinksData } from '../../../../utils/requestsUtils/functionsRequests/TrackingLinks/trackingLinksFunctions'
import LoadingSpinner from '../../../../components/LoadingSpinner'
import moment from 'moment'


const TrackingLinksInfluencersScreen = () => {
    
    const { t, i18n } = useTranslation()
    const dispatch = useAppDispatch()

    const initialState = {
        id: { error: "", value: "", touched: false, checkValue: (x: string | number, dv?: boolean) => new MyYup(x, i18n.language, dv).isRequired().links()},
        name: { error: "", value: "", touched: false, checkValue: (x: string | number, dv?: boolean) => new MyYup(x, i18n.language, dv).isRequired().links()},
    }

    const [inputValues, setInputValues] = useState<ValuesForm>(initialState);  
    const [loading, setLoading] = useState(false)

    const influencersData = useSelector((state: RootState) => state.trackingLinksInfluencers.influencersData)

    useEffect(() => {
        
        dispatch( GetTrackingLinksInfluencersThunk() )

        return () => {
        
        }
    }, [])

    const handleExport2 = () => {
        const data = influencersData.dataRow
        const worksheet = XLSX.utils.json_to_sheet(data);
        
        worksheet["!cols"] = [
            { wch: 20 }, 
            { wch: 20 }, 
            { wch: 20 }, 
            { wch: 20 }, 
        ];

        const range = XLSX.utils.decode_range(worksheet['!ref']);

        // Iterate through each row starting from the second row (to skip headers)
        for (let R = range.s.r + 1; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                // Construct the cell address
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });

                // Get the cell object
                const cell = worksheet[cellAddress];

                // Check if the cell exists and contains a value
                /*
                if (cell && cell.v !== undefined) {
                    // Apply the style depending on value
                    if (cell.v === true || cell.v === "Completos" || cell.v === "Verificada" || cell.v === "Subida") {
                        cell.s = { fill: { fgColor: { rgb: "FF92D050" } } }; // Green background
                    } else if (cell.v === false || cell.v === "Incompletos" || cell.v === "No Verificada" || cell.v === "No Subida") {
                        cell.s = { fill: { fgColor: { rgb: "FFF8CBAD" } } }; // Red background
                    }
                }
                    */
            }
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const date = moment().format("YYYY-MMMM-DD---HH-mm-SS")
        // Convert the workbook to a binary file and trigger the download
        XLSX.writeFile(workbook, `${date}.xlsx`);
    };


    const onEditName = (value: InfluencerDataCount, newValue: string) => {
        const newData = {
            ...value,
            name: newValue
        }
        dispatch( setEditTrackLinkState(newData) )
    }


    const onActive = (value: InfluencerDataCount) => {
        const newData = {
            ...value,
            active: !value.active
        }
        dispatch( setEditTrackLinkState(newData) )
    }


    const onSave = (id: string) => {
        const selectedDataToSave = influencersData.influencerDataCount.find(d => d.id === id)

        if(!selectedDataToSave){
            return
        }

        setLoading(true)
        updateTrackingLinksData(id, { name: selectedDataToSave.name })
        .then(() => {

        }).catch(() => {
            alert("Error updating data")
        }).finally(() => {
            setLoading(false)
        })
    }

    const onDelete = (id: string) => {

        setLoading(true)
        deleteTrackingLinksData(id)
        .then(() => {
            dispatch( setDeleteTrackLinkState(id) )
        }).catch(() => {
            alert("Error deleting data")
        }).finally(() => {
            setLoading(false)
        })
    }


    const onChangeValueInput = (newEvent: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        checkErrors(newEvent, inputValues, setInputValues)
    }


    const onChangeFocusInput = (name: string) => {
        setInputValues({...inputValues, [name]: {...inputValues[name], touched: true}}) 
    }



    const handleSubmit = (e: any) => {
        e.preventDefault()

        let existsError = false;
        for(const nameInput in inputValues){
            if(checkErrorsWhenSubmit(nameInput, inputValues))
                existsError = true
        }
        setInputValues({...inputValues})

        if(existsError){
            return
        }
            


        const id = inputValues["id"].value
        const name = inputValues["name"].value

        const bodySubmit: CreateTrackingLinkBody = {
            id,
            name,
        }

        const body: InfluencerDataCount = {
            ...bodySubmit,
            active: true,
            operative_systems: []
        }

        setLoading(true)
        createTrackingLinksData(bodySubmit)
        .then(() => {
            setInputValues(initialState)
            dispatch( setAddTrackLinkState(body) )
        }).catch(() => {
            alert("Error creating data")
        }).finally(() => {
            setLoading(false)
        })
        /*
        notifCustomUser({ title, body, topic })
        .then(() => {
            dispatch(resetManageUsersModalsReducer())
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })
            */
    }

    console.log("influencersData?.influencerDataCount", influencersData)

    return (
        <div className="width-100 height-100">

            <div className="flex flex-jc-sb">
                <p className="title-screen">{"Influencers data"}</p>
                <button
                    onClick={handleExport2}
                    className="c-white fs-12 picton-blue-bg export-form-btn"
                >
                    Export
                </button>
            </div>

            <form className="flex flex-ai-center" onSubmit={handleSubmit}>
                <div className="mr-20">
                    <GeneralInputTitle 
                        title={"Id"}
                        name={"id"}
                        value={inputValues["id"].value}
                        onChange={onChangeValueInput}
                        onFocus={onChangeFocusInput}
                        placeholder={"Id"}
                        error={inputValues["id"].error}
                    />
                </div>
                <div className="mr-20">
                    <GeneralInputTitle 
                        title={`Name`}
                        name={"name"}
                        value={inputValues["name"].value}
                        onChange={onChangeValueInput}
                        onFocus={onChangeFocusInput}
                        placeholder={"Name"}
                        error={inputValues["name"].error}
                    />
                </div>

                <div className="mb-12">
                    <ConfirmButton text={t("General:label_016")} width="10rem" />
                </div>
            </form>

            <div className="mt-20">
                <div className="flex">
                    {
                        ["ID-influencers", "Nombre", "Android", "iOS", "Windows", "macOS", "Total", "Estatus"].map((str, index) => {
                            return (
                                <p key={str} className={`fs-14 ${str}-link`}>{str}</p>
                            )
                        })
                    }
                </div>
                    {
                        influencersData?.influencerDataCount?.map((data) => {
                            // original
                            /*
                                Android
                                iOS
                                macOS
                                Windows
                            */
                            const android = data.operative_systems.find((a) => a.operative_system.toLowerCase().indexOf("android") > -1)?.count ?? 0
                            const iOS = data.operative_systems.find((a) => a.operative_system.toLowerCase().indexOf("ios") > -1)?.count ?? 0
                            const macOS = data.operative_systems.find((a) => a.operative_system.toLowerCase().indexOf("macos") > -1)?.count ?? 0
                            const Windows = data.operative_systems.find((a) => a.operative_system.toLowerCase().indexOf("windows") > -1)?.count ?? 0
                            return (
                                <div className="flex mt-12" key={data.id}>
                                    <p className="fs-14 ID-influencers-link">{data.id}</p>
                                    <input 
                                        onChange={(e) => onEditName(data, e.target.value)}
                                        value={data.name}
                                        className="fs-13 Nombre-link"
                                    />
                                    <p className="fs-14 Android-link">{android}</p>
                                    <p className="fs-14 iOS-link">{iOS}</p>
                                    <p className="fs-14 Windows-link">{Windows}</p>
                                    <p className="fs-14 macOS-link">{macOS}</p>
                                    <p className="fs-14 Total-link">{`${data.operative_systems.reduce((sum, o) => sum + o.count, 0)}`}</p>
                                    {
                                        data.active ?
                                        <React.Fragment>
                                            <div className="">
                                                <p className="fs-14">{"Activo"}</p>
                                            </div>
                                            <div className="">
                                                <button
                                                    className="pointer ml-20 fs-14"
                                                    onClick={() => onSave(data.id)}
                                                >
                                                    {"Guardar"}
                                                </button>
                                            </div>
                                            <div className="">
                                                <button
                                                    className="pointer ml-20 fs-14"
                                                    onClick={() => onDelete(data.id)}
                                                >
                                                    {"Eliminar"}
                                                </button>
                                            </div>
                                        </React.Fragment>
                                        :
                                        <div className="">
                                            <p className="fs-14">{"Eliminado"}</p>
                                        </div>
                                    }
                                </div>
                            )
                        })
                    }
            </div>

            {
                loading &&
                <LoadingSpinner fullPage={false} />
            }
        
        </div>
    )
}

export default TrackingLinksInfluencersScreen